/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAuthorizationDataResponse
 */
export interface GetAuthorizationDataResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizationDataResponse
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizationDataResponse
     */
    email?: string | null;
}

/**
 * Check if a given object implements the GetAuthorizationDataResponse interface.
 */
export function instanceOfGetAuthorizationDataResponse(value: object): value is GetAuthorizationDataResponse {
    return true;
}

export function GetAuthorizationDataResponseFromJSON(json: any): GetAuthorizationDataResponse {
    return GetAuthorizationDataResponseFromJSONTyped(json, false);
}

export function GetAuthorizationDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAuthorizationDataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function GetAuthorizationDataResponseToJSON(json: any): GetAuthorizationDataResponse {
    return GetAuthorizationDataResponseToJSONTyped(json, false);
}

export function GetAuthorizationDataResponseToJSONTyped(value?: GetAuthorizationDataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone': value['phone'],
        'email': value['email'],
    };
}

